import type { State } from 'state';
import type { UserRequestsCounts } from 'state/persisted/user-requests-counts';

export const getUserRequestsCounts = (state: State): UserRequestsCounts => {
    return state.persisted.userRequestsCounts;
};
